import { render, staticRenderFns } from "./DrillScoringAiMath.vue?vue&type=template&id=29843c13&scoped=true&lang=pug&"
import script from "./DrillScoringAiMath.vue?vue&type=script&lang=ts&"
export * from "./DrillScoringAiMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillScoringAiMath.vue?vue&type=style&index=0&id=29843c13&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29843c13",
  null
  
)

export default component.exports